import { defineMessages } from 'react-intl';

export const scribePlusRetainedFeatureListMessages = defineMessages({
  // ── Section labels ───────────────────────────────────────────────────
  sectionLabelScribePlus: {
    defaultMessage: 'Your current plan (<link>formerly Heidi Pro</link>) includes:',
    id: '4jPQn7NWNz',
    description:
      'Section header above the Scribe Plus retained-features list; <link> wraps "formerly Heidi Pro" as an inline link to the plan-changes FAQ',
  },
  sectionLabelScribeTeam: {
    defaultMessage: 'Your current plan (<link>formerly Practice</link>) includes:',
    id: 'DjdlsA/Qrr',
    description:
      'Section header above the Scribe Team retained-features list; <link> wraps "formerly Practice" as an inline link to the plan-changes FAQ',
  },

  // ── Shared retained-feature rows (both variants) ────────────────────
  limitedInSessionAnswers: {
    defaultMessage: 'Limited in-session answers',
    id: 'TepA7uJO4C',
    description:
      'Retained-feature row label: capped evidence answers inside patient sessions',
  },
  limitedInSessionAnswersTooltip: {
    defaultMessage: 'Evidence-backed answers, calculations, and handout exports',
    id: 'Hqm5oqmwjd',
    description:
      'Tooltip next to the "Limited in-session answers" row on the retained-feature list',
  },
  limitedInSessionAnswersTooltipAriaLabel: {
    defaultMessage: 'More about limited in-session answers',
    id: 'mfZihOfG0o',
    description:
      'Accessible label for the limited-in-session-answers info control on the retained-feature list',
  },
  advancedNoteTemplates: {
    defaultMessage: 'Advanced note templates',
    id: 'JxBVWEyXc2',
    description:
      'Retained-feature row label: access to the advanced / premium note template library',
  },
  unlimitedAiNoteEditing: {
    defaultMessage: 'Unlimited AI note editing (Formerly Ask Heidi)',
    id: 'SrYVXLpoKj',
    description: 'Retained-feature row label: unlimited AI-assisted note editing',
  },

  // ── Scribe Team only ───────────────────────────────────────────────
  outOfSessionEvidence: {
    defaultMessage: 'Out-of-session Evidence',
    id: '8BFi3gsNWA',
    description:
      'Scribe Plus / Scribe Team retained-feature row: ability to use Evidence outside of patient sessions (chat surface) — kept after the trial ends',
  },
});
